import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./pressure.css";

import { Link } from "react-router-dom";
export default function ThermographieInfrarougeView() {
  const sliderSettings = {
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 700,
    pauseOnHover: false,
  };

  return (
    <>
      <Header />

      <main className="prs">
        {/* ===== HERO ===== */}
        <section className="prs-hero">
          <div className="prs-hero__text">
            <h1>Thermographie Infrarouge</h1>
            <p>
              VERATRAC SAFETY réalise des inspections thermographiques pour
              détecter les échauffements anormaux et les défauts invisibles à
              l’œil nu, en électricité, bâtiment et industrie — sans arrêt de
              production.
            </p>

            <div className="prs-hero__bullets">
              <span>🌡️ Cartographie thermique</span>
              <span>⚡ Prévention incendie</span>
              <span>🏢 Performance énergétique</span>
            </div>

            <a href="#contact" className="btn-primary">Demander un diagnostic</a>
          </div>

          <div className="prs-hero__slider">
            <Slider {...sliderSettings}>
              <div><img src="/images/thermo/1.jpg" alt="Inspection IR d’un tableau électrique" /></div>
              <div><img src="/images/thermo/2.jpg" alt="Thermographie de façade" /></div>
              <div><img src="/images/thermo/3.jpg" alt="Contrôle thermique en process" /></div>
              <div><img src="/images/thermo/4.jpg" alt="Analyse de points chauds" /></div>
            </Slider>
          </div>
        </section>

        {/* ===== CONTENU ===== */}
        <section className="prs-reglement prs-simple">
          <h2>Principe</h2>
          <p>
            La thermographie repose sur la mesure du rayonnement infrarouge émis
            par les surfaces. En tenant compte de l’<strong>émissivité</strong>,
            nous comparons les températures de zones similaires pour repérer les
            anomalies (points chauds/froids, hétérogénéités).
          </p>

          <h3>Pourquoi contrôler par thermographie ?</h3>

          <h4>Électricité</h4>
          <ul>
            <li>Prévenir les départs de feu (mauvais serrage, isolement dégradé, surcharge).</li>
            <li>Assurer la disponibilité des installations et réduire les arrêts.</li>
            <li>Répondre aux demandes des assureurs incendie (meilleures conditions).</li>
          </ul>

          <h4>Bâtiment</h4>
          <ul>
            <li>Détecter infiltrations en toiture et zones humides.</li>
            <li>Localiser les défauts d’isolation et fuites d’air (ponts thermiques, menuiseries).</li>
            <li>Optimiser la performance énergétique des bâtiments.</li>
          </ul>

          <h4>Industrie</h4>
          <p>Applications types :</p>
          <ul>
            <li>Calorifuges et réfractaires (pertes, points chauds).</li>
            <li>Paliers, roulements, vannes, armoires de régulation.</li>
            <li>Tuyauteries, réseaux vapeur, contrôle des températures de process.</li>
          </ul>

          <h3>Cadre & recommandations</h3>
          <p>
            Il n’existe pas de texte rendant la thermographie obligatoire ; en
            revanche, la <strong>FMSAR</strong> (assureurs) recommande des
            inspections régulières, notamment pour les sites à risques.
          </p>

          <h3>Livrables</h3>
          <ul>
            <li>Rapport illustré (thermogrammes / photos réelles / commentaires).</li>
            <li>Tableau des anomalies classées par criticité.</li>
            <li>Recommandations d’actions correctives et suivi.</li>
          </ul>

          
          
          <p>
            Notre retour d’expérience couvre de nombreuses <strong>installations
            industrielles</strong> et sites tertiaires — de l’audit préventif aux
            expertises post-incident.
          </p>

          <div className="prs-btns">
            <Link to="/#contact" className="btn-primary">faire une consultation</Link>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}
